{
    "NAVIGATION_INFO_MANUAL": "{{source}} manual"
}